import React from 'react';

/**
 * Given a component,
 * returns it wrapped inside a layout component,
 * passing along some props to the layout.
 */
const withLayout = (
    Component: React.FC<any>,
    Layout: React.FC<any>,
    layoutProps = {},
) => {
    const LayoutComponent = (props?: object) => {
        return (
            <Layout {...layoutProps}>
                <Component {...props} />
            </Layout>
        );
    };
    const componentName = (Component.displayName ?? Component.name) ?? 'Unknown';
    LayoutComponent.displayName = `Layout(${componentName})`;

    // Need something to fetch initial props
    return LayoutComponent;
};

export default withLayout;
